import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {ActivityPeriod, ActivityPeriodEntity} from "../../../model/activity-period";

export interface ActivityPeriodSelectorProps {
  regionId?: string
}

const getRegionIdParam = createParamSelector<ActivityPeriodSelectorProps | undefined, string | undefined>(params => params?.regionId);

export const activityPeriodsSelector = () => createSelector(
  [getUseQueryResultData<ActivityPeriod[]>, getRegionIdParam],
  (data, regionId) => {
    return selectActivityPeriodsAndTransform(
      data ?? [], {
        regionId: regionId,
      }
    );
  }
);

export const activityPeriodSelector = () => createSelector(
  [getUseQueryResultData<ActivityPeriod>],
  (data) => {
    return data ? transformActivityPeriod(data) : undefined;
  }
);

export const selectActivityPeriods = (values?: ActivityPeriod[], selector?: ActivityPeriodSelectorProps): ActivityPeriod[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformActivityPeriod = (value: ActivityPeriod): ActivityPeriodEntity => {
  return ActivityPeriodEntity.from(value)
}

export const selectActivityPeriodsAndTransform = (values?: ActivityPeriod[], selector?: ActivityPeriodSelectorProps): ActivityPeriodEntity[] => {
  const selected = selectActivityPeriods(values, selector);
  return selected.map(transformActivityPeriod);
};
